import { fetchSettingsFromAPI, getSettingsFromStorage } from "../../api/settingsService";

export const FETCH_SETTINGS_REQUEST = "FETCH_SETTINGS_REQUEST";
export const FETCH_SETTINGS_SUCCESS = "FETCH_SETTINGS_SUCCESS";
export const FETCH_SETTINGS_FAILURE = "FETCH_SETTINGS_FAILURE";

export const fetchSettingsRequest = () => ({
  type: FETCH_SETTINGS_REQUEST
});

export const fetchSettingsSuccess = (settings) => ({
  type: FETCH_SETTINGS_SUCCESS,
  payload: settings
});

export const fetchSettingsFailure = (error) => ({
  type: FETCH_SETTINGS_FAILURE,
  payload: error
});

export const fetchSettings = () => {
  return async (dispatch) => {
    dispatch(fetchSettingsRequest());
    
    const result = await fetchSettingsFromAPI();
    
    if (result.success) {
      dispatch(fetchSettingsSuccess(result.data));
    } else {
      dispatch(fetchSettingsFailure(result.error));
    }
  };
};

export const loadSettingsFromStorage = () => {
  return (dispatch) => {
    const settings = getSettingsFromStorage();
    if (settings) {
      dispatch(fetchSettingsSuccess(settings));
    }
  };
};
